<template>
  <h1
    class="page-title-section"
    :class="[
      colorType ? `page-title-section--${colorType}` : null,
      { 'page-title-section--is-pc': isPc },
    ]"
  >
    <span>{{ pageTitle }}</span>
  </h1>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * ページタイトル セクション
 */
export default defineComponent({
  name: 'PageTitleSection',
  props: {
    /**
     * ページタイトル
     */
    pageTitle: {
      type: String,
      required: true,
      default: '',
    },
    /**
     * カラータイプ
     */
    colorType: {
      type: String,
      default: '',
    },
  },
  setup() {
    const isPc = DeviceInfo.isForPC()
    return {
      isPc,
    }
  },
})
</script>

<style lang="scss" scoped>
.page-title-section {
  @include fontSetTitleBold(16);

  color: #fff;
  z-index: 2;

  &--light {
    color: $black;
  }

  &--is-pc {
    position: absolute;
    right: 50%;
    transform: translateX(50%);
  }
}
</style>
